import { AlertTriangle, CheckCircle2, Circle, Info, XCircle } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

import type { StatusTone } from '../../utils/run-status';

/**
 * The ONE tone vocabulary for the Content section. Every badge, chip, stat and
 * callout reads its classes from here so a "warning" looks the same everywhere.
 */

/** Soft pill: tinted background + coloured text. */
export const TONE_SOFT: Record<StatusTone, string> = {
  info: 'bg-info-50 text-info',
  success: 'bg-success-50 text-success',
  warning: 'bg-warning-50 text-warning',
  error: 'bg-error-50 text-error',
  muted: 'bg-muted text-muted-foreground',
};

/** Plain coloured text, for counts and inline values beside a label. */
export const TONE_TEXT: Record<StatusTone, string> = {
  info: 'text-info',
  success: 'text-success',
  warning: 'text-warning',
  error: 'text-error',
  muted: 'text-muted-foreground',
};

/** Callout surface: tinted background with a matching border. */
export const TONE_SURFACE: Record<StatusTone, string> = {
  info: 'border-info/20 bg-info-50',
  success: 'border-success/20 bg-success-50',
  warning: 'border-warning/30 bg-warning-50',
  error: 'border-error/30 bg-error-50',
  muted: 'border-border bg-muted/60',
};

/** Solid dot / bar fill. */
export const TONE_FILL: Record<StatusTone, string> = {
  info: 'bg-info',
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-error',
  muted: 'bg-muted-foreground/50',
};

/** Icon per tone — status is never shown by colour alone. */
export const TONE_ICON: Record<StatusTone, LucideIcon> = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  error: XCircle,
  muted: Circle,
};
